module.exports = __webpack_public_path__ + "static/media/S3N6.0e52a5ed.svg";